import { Box } from '@mui/material';
import {
  InsufficientAccessBackground,
  PersonDetailSection,
  PersonHeaderSection,
  StyledActivityCardBackground,
  useAccessState
} from 'modules';
import React from 'react';



export type PersonActivityProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const PersonActivity = (props: PersonActivityProps) => {
  const access = useAccessState('Person');
  if (!access.view) {
    return (
      <InsufficientAccessBackground.FC />
    );
  }
  return (
    <StyledActivityCardBackground.FC>
      <Box
        height='calc(100vh - 10rem)'
        display='flex'
        flexDirection='row'
        justifyContent='stretch'
        columnGap='1rem'
      >
        <PersonDetailSection.FC />
        <PersonHeaderSection.FC />
      </Box>
    </StyledActivityCardBackground.FC>
  );
};
